module.exports = __webpack_public_path__ + "img/9788952217981.7402005e.jpg";